import { CSSBreakpoint } from './helpers.js';
import { debounce } from './helpers';

export default class MainMenu {
  constructor() {
    if ((this.menuTrigger = document.querySelector('.main-menu-trigger'))) {
      this.pageOverlay = document.querySelector('.page-overlay');
      this.menuItems = document.querySelectorAll('.main-menu-nav-link');

      this._handleClicks();

      if (document.body.classList.contains('page-internet')) {
        window.addEventListener('resize', () => {
          this._hidePageOverlay();

          // window.addEventListener("resize", debounce(() =>
          //     this._hidePageOverlay(), 2500))
        });
      }
    }
  }

  _handleClicks() {
    this.menuTrigger.addEventListener('click', (e) => {
      if (this.menuTrigger.contains(e.target)) {
        e.preventDefault();
        document.body.classList.toggle('main-menu-active');
        document.body.classList.toggle('overlay-active');

        this.pageOverlay.addEventListener('click', (event) => {
          if (this.pageOverlay.contains(event.target)) {
            document.body.classList.remove('main-menu-active');
            document.body.classList.remove('overlay-active');
          }
        });

        this.menuItems.forEach((element) => {
          if (element.hash !== '') {
            element.addEventListener('click', (e) => {
              document.body.classList.remove('main-menu-active');
              document.body.classList.remove('overlay-active');
            });
          }
        });
      }
    });
  }

  _hidePageOverlay() {
    if (window.innerWidth >= CSSBreakpoint.large) {
      document.body.classList.remove('main-menu-active');
      document.body.classList.remove('overlay-active');
    }
  }
}
